import styled, { keyframes } from "styled-components";
import logoBlack from "../../assets/logo_black.svg";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #FFFFFF;
  animation: ${fadeIn} 0.3s ease-in;
`;

const Logo = styled.img`
  width: 200px;
  height: auto;
  margin-bottom: 2rem;
  animation: ${pulse} 2s ease-in-out infinite;
`;

const LoadingText = styled.div`
  font-family: Inter, system-ui, sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  color: #333333;
  letter-spacing: 0.05em;
  animation: ${pulse} 2s ease-in-out infinite;
`;

export const LoadingScreen = () => {
  return (
    <LoadingContainer>
      <Logo src={logoBlack} alt="Snowboarding CO2" />
      <LoadingText>Caricamento...</LoadingText>
    </LoadingContainer>
  );
};
